import { ResourceTypeLink } from "@evergis/api";
import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { declension } from "../../../utils/declension";
import { MAX_TOOLTIP_ITEMS_LENGTH } from "./const";
import { TooltipGroup, TooltipGroupItem, TooltipTextLine } from "./styled";

type ResourcesTooltipProps = {
  myLabel?: string;
  otherLabel?: string;
  resources: string[];
  otherResources?: string[];
  resourceType?: ResourceTypeLink;
};

export const ResourcesTooltip: FC<ResourcesTooltipProps> = ({
  resources,
  otherResources,
  resourceType = ResourceTypeLink.Layer,
  myLabel,
  otherLabel,
}) => {
  const { t } = useTranslation("dialogs");
  const translations = useMemo(
    () => ({
      [ResourceTypeLink.Layer]: {
        myTitle: t("deleteLayer.myLayers"),
        othersTitle: t("deleteLayer.otherLayers"),
        resource1: t("layer1", { ns: "catalog" }),
        resource2: t("layer2", { ns: "catalog" }),
        resource3: t("layer3", { ns: "catalog" }),
      },
      [ResourceTypeLink.Project]: {
        myTitle: t("deleteResources.myMaps"),
        othersTitle: t("deleteLayer.otherMaps"),
        resource1: t("map1", { ns: "catalog" }),
        resource2: t("map2", { ns: "catalog" }),
        resource3: t("map3", { ns: "catalog" }),
      },
      [ResourceTypeLink.Table]: {
        myTitle: t("deleteResources.myTables"),
        othersTitle: t("deleteResources.otherTables"),
        resource1: t("table1", { ns: "catalog" }),
        resource2: t("table2", { ns: "catalog" }),
        resource3: t("table3", { ns: "catalog" }),
      },
    }),
    [t],
  );

  return (
    <>
      {resources.length > 0 && (
        <TooltipGroupItem>
          <TooltipGroup>{myLabel || translations[resourceType].myTitle}</TooltipGroup>
          {resources.slice(0, MAX_TOOLTIP_ITEMS_LENGTH).map((reference, index) => (
            <TooltipTextLine key={index}>{reference}</TooltipTextLine>
          ))}
          {resources.length > MAX_TOOLTIP_ITEMS_LENGTH && (
            <TooltipTextLine>
              + {resources.length - MAX_TOOLTIP_ITEMS_LENGTH}{" "}
              {declension(
                translations[resourceType].resource1,
                translations[resourceType].resource2,
                translations[resourceType].resource3,
                resources.length - MAX_TOOLTIP_ITEMS_LENGTH,
              )}
            </TooltipTextLine>
          )}
        </TooltipGroupItem>
      )}
      {otherResources?.length > 0 && (
        <TooltipGroupItem>
          <TooltipGroup>{otherLabel || translations[resourceType].othersTitle}</TooltipGroup>
          <TooltipTextLine>
            {otherResources.length}{" "}
            {declension(
              translations[resourceType].resource1,
              translations[resourceType].resource2,
              translations[resourceType].resource3,
              otherResources.length,
            )}
          </TooltipTextLine>
        </TooltipGroupItem>
      )}
    </>
  );
};
